import * as userRequest from "@/utils/userRequest";

export default async function getMissionsService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("mission/list", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("🚀 ~ getMissionsService ~ res:", res);
        if (res.success) {
            onSuccess && onSuccess(res.data);
            return res.data;
        }
    } catch (err) {
        console.error("🚀 ~ getMissionsService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
